type FirebaseConfig = {
  apiKey?: string;
  authDomain?: string;
  projectId?: string;
  storageBucket?: string;
  messagingSenderId?: string;
  appId?: string;
  measurementId?: string;
  vapidKey?: string;
};

const hasFirebaseConfig = (config: FirebaseConfig) =>
  Boolean(
    config.apiKey &&
      config.authDomain &&
      config.projectId &&
      config.messagingSenderId &&
      config.appId &&
      config.vapidKey,
  );

export const registerRiderServiceWorker = async (config: FirebaseConfig) => {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  try {
    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    await registration.update();

    if (hasFirebaseConfig(config)) {
      const readyRegistration = await navigator.serviceWorker.ready;
      readyRegistration.active?.postMessage({
        type: 'FIREBASE_CONFIG',
        config,
      });
    }
  } catch (error) {
    console.warn('Rider service worker registration failed', error);
  }
};
